@if (quoteRequestForm) {
  <div class="cipx-form-form-group" *ngFor="let question of questions()">
    @if (additionalQuestionsGroup.get(question.question_code) && isVisible(question)) {
      <cipx-quote-request-intake-form-question-control
        [question]="question"
        [group]="additionalQuestionsGroup"></cipx-quote-request-intake-form-question-control>
    }
  </div>
}
